import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import ContentCards from "../components/homepage/contentCards";
import CustomizedAccordions from "../components/homepage/accordion";
import CustomContainer from "../components/layout/container";
import CustomHeader from "../components/layout/header";

import whoMGEM from "../images/Flow_orange3_mGEM_600_200.jpg";
import whoConsult from "../images/Consultancy_LightBulb_600_200.jpg";
import whoFundMan from "../images/Fund_Manage_Purple1_600_200.jpg";
import whoEnerEmis from "../images/Baltic_Wind_SkyOrange_600_200_01a.jpg";
import whoUnivHE from "../images/HE_Graduation_Blue_Original_600_200_01a.jpg";


const carouselHeight = "150px";
const Who = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { whoSubPage } = useParams();

  const router = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [links, setLinks] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] = useState("");

  const getRouterData = () => {
    if (whoSubPage) {
      const url = whoSubPage.replace(/-/g, " ");
      setLinks(url)
      const finalString = url
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      setPageTitle(finalString);
      setTimeout(() => {
        setborderColorToHighlight(theme.palette.primary.dark);
      }, 100);
    }
  };

  const breadcrumbData = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: `Who (${pageTitle})`,
      link: `/who/${whoSubPage}`,
    },
  ];

  useEffect(() => {
    getRouterData();
  }, [whoSubPage]);

  return (
    <Box>
      <CustomContainer>
        <title>Who | Manchester Economic Forecasting</title>
        <meta
          name="description"
          content=" Identify & Quantify Macroeconomic/Esg risk"
        />
      </CustomContainer>
      <CustomHeader
        title={`Who ?<span style="font-size: 20px;color:rgba(84,77,160,1);">- Users of MEF Services: </span> `}
        breadcrumbData={breadcrumbData}
      />
      <CustomContainer>
        <Box >
          {/* <Typography
          color="#00a0a0" variant="h3" align="left" fontWeight={700} mb={1.5} >
        Users of MEF Services: <span style="font-size:1.2rem;color:rgba(84,77,160,1);"> - Smart Economic Scenarios/Apps to Mitigate Global Risk</span>
        </Typography> */}

          {/* MT - Need to remove breadcrumb as causing subtitle to wrap !! */}

          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={whoMGEM}
                title="Exporters/SMEs & Consultancies"
                objectFit="contain"
                subTitle="Quantify Global (Trade) Risks"
                borderColor={
                  links == "exporters" ? borderColorToHighlight : "none"
                }
                body={`Using MEF's <a href='/how/mGEM-global-macro' title="macro Global Econometric Model">mGEM</a> model, we start from <b>Official macro/budget</b> announcements as a 
              central economic forecast projection or baseline. MEF can then scenario-test critical official assumptions (eg interest/exchange rates) in the baseline that impact a 
              client's or <b>SME's</b> specific business areas to quantify <b>de-facto risk exposure</b> to the Global economy`}
              />
              {/* <CustomizedAccordions
              title="Pre-Run Scenario Service"
              body={`In more detailed, bespoke scenario analysis, MEF can test particular, client-specific, risk concerns over official macro/energy/emissions forecasts
              - it might be that some announced policy settings are not deemed credible even thought they are crucial drivers of official forecasts. `}
            /> */}
              <CustomizedAccordions
                title="risk2NZ App - Pre-Run Macro Scenarios"
                body={`Each quarter, MEF produces several,highly-relevant, pre-configured macro scenarios which cover significant current areas of both macro 
              and financial risk at Global and/or UK levels. MEF's <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App contains a number of these, pre-configured 
              scenarios that explore "shocks" to key exogenous/policy inputs (eg US Federal Funds interest rate) to quantify sensitivities of official Economic/Energy forecasts. 
              risk2NZ has animated country response charts & Global, geographic heatmaps to help visualise & interpret scenario impacts & spillovers.
              The <b>"Macro-Map</b>", "<b>Links-Trade</b>" and "<b>Links-Macro</b>" are the most relevant Tabs in risk2NZ for Exporters/SMEs.
              MEF can also make its pre-run scenario outputs available for clients who simply wish to access fully-consistent Global drivers of their own
              in-house, domain-level, scenario analysis`}
              //   body={`The <b>"Macro-Map</b>", "<b>Links-Trade</b>" and "<b>Links-Macro</b>" are the most relevant Tabs in risk2NZ for Exporters/SMEs.
              // MEF can also make its pre-run scenario outputs available for clients who simply wish to access fully-consistent Global drivers of their own
              // in-house, domain-level, scenario analysis`}
              />
              <CustomizedAccordions
                title="Bespoke Scenarios/Models-mGEM driven"
                body={`MEF can tailor its bespoke scenario service to serve clients who also wish to commission proprietary, <b>satellite models</b> that forecast their specific domains/markets.
              The client will then typically own the bespoke model, but it is built, run & maintained by MEF.  <a href='/how/mGEM-global-macro'  title="macro Global Econometric Model">mGEM</a> macro scenarios 
              outputs/drivers can be easily fed into it. MEF can also construct SME-specific weighted indices of overall export/demand prospects across all the SME's key export markets. mGEM shocks at a Global/National 
              level can then be translated into market-specific impacts for customised SME risk analysis.  `}
              />
              {/* <CustomizedAccordions
                title="Case Studies"
                body={`Links to specific Case Studies HERE`}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={whoEnerEmis}
                title="Energy/Emissions Analysts"
                subTitle="Test Emissions-Macro Sensitivities"
                // MT added
                objectFit="contain"
                borderColor={
                  links == "energy analysts"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Energy/Emissions forecasts are often based on simplistic <b>"straight-line" assumptions</b> about Global economic activity. Using MEF's <a href='/how/eGEM-global-emissions'  title="industry Global Econometric Model">iGEM</a>  and <a href='/how/enGEM-global-energy' title="emissions Global Econometric Model">eGEM</a> models, we can derive  
              "bottom-up" (ie adjusted for industry-mix) forecasts & scenarios for Energy/Emissions that are fully consistent with more <i>realistic</i> <a href='/how/mGEM-global-macro'  title="macro Global Econometric Model">mGEM</a> forecast/scenario pathways to 2050.`}
              />
              <CustomizedAccordions
                title="risk2NZ App Macro-Emissions Scenarios"
                body={`
              Macroeconomic and/or GreenTech scenario analysis is essential to explore huge uncertainties in (Global) economic & technological pathways to 2050
              Output growth dominated by <a title="GreenHouse Gases"> GHG</a>-intensive sectors will obviously imply higher national emissions than otherwise - so understanding the industrial mix
              of output evolution is crucial for Net Zero analysis/projections. <a title="industry Global Econometric Model">iGEM</a> allows the feed-through of mGEM Global/National economic shocks to 12 industrial sectors across the majority of the 53 economies/zones covered by mGEM.
              MEF's <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App can also explore impacts of (Global) macro scenarios on Corporate decarbonisation trajectories relative to sectoral Carbon Intensity budgets.`}
              />
              <CustomizedAccordions
                title="Bespoke Energy/Emissions Models & Pathways"
                body={` MEF can construct customised client models that are driven by by either macro and/or industrial-sector outputs from MEF's model suite. Energy/Emissions
              analysts can then ensure their 2050 pathways are fully consistent with realistic, Global, macroeconomic driver variables; and that the latter drivers can then be fully 
              "stress-tested" in a consistent way using bespoke scenario analysis. `}
              //              MEF can conduct macro-industrial sector risk analysis using mGEM add-on <a title="industry Global Econometric Model">iGEM</a>; capture Sectoral & Energy/Emissions impacts of Global macro shocks maybe from a bespoke macro forecast base.
              //              Such Global/National shocks can then reveal Corporate level Carbon exposure and thus Green taxation exposure
              />
              {/* <CustomizedAccordions
                title="Case Studies"
                body={`Links to specific Case Studies HERE`}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={whoUnivHE}
                title="Higher Education Sector"
                subTitle="Real World Risk Models/Tools/Apps"
                // MT added
                objectFit="contain"
                borderColor={
                  links == "higher education institutions"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`The <a href='/what/risk2NZ-app' title="risks to Net Zero mobile App" > risk2NZ </a> App brings Business, Investment and<a title="Environmental,
               Societal & Governmental"> Esg </a> <b>risk/scenario analysis to the classroom</b> - from undergraduate, postgrad/MBA to Executive Education. Its fully customisable to courses
              across Economics, Business/Finance, Geography/Climate, Econometrics/Data Science - a key data tool for lectures and (self-directed) student tutorials.`}
              />
              <CustomizedAccordions
                title="risk2NZ App-Business Risk Tools in Class"
                body={`The <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App is a front-end to MEF's model suite that is customisable for subject area deployment[; a free, cut-down, version
                of the App is available - <a href="/download/riskNZliteSignUp.tsx">Sign Up Here</a> App subscription enables students to be fully grounded in applied data awareness/visualisation, 
                policy trade-offs and operation of  smart scenario analysis; it helps fills the gap in most (theory-dominated) course units in Economics, Business & Finance. risk2NZ thus helps equip students
                with the applied skills/tools needed to assist in Carbon transformation in their future careers. `}
              />
              <CustomizedAccordions
                title="Custom Applied Course Units"
                body={`MEF has a long history of devising and delivering custom education courses at University/CPD qualifications. It can bring business-level applied risk tools into the classroom.
              Custom programs designed around applied business risk tools - such as <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> - help to maximise Macro/Emissions & <a title="Environmental, Societal & Governmental"> Esg </a> awareness among Economics, Finance & MBA students. 
              Whilst essential for the applied skills of (post)graduates, <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> is ideal for CPD & staff training up-skilling.
              It can be readily deployed in remote-learning environments too and integrated with Blackboard, Moodle & other ILEs.`}
              />
              {/* <CustomizedAccordions
                title="Case Studies"
                body={`Links to specific Case Studies HERE`}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={3.0}>
              <ContentCards
                imgSrc={whoFundMan}
                title="Investment/Fund Managers"
                subTitle="Explore Portfolio/Esg Risk"
                // MT added
                objectFit="contain"
                borderColor={
                  links == "investment managers"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Using MEF's <a title="finance Global Econometric Model" href='/how/finGEM-global-finance'>finGEM</a> and <a title="energy Global Econometric Model" href='/how/enGEM-global-energy'>enGEM</a> models, we can explore both 
              <b>macro, technology and (Green) policy shocks</b> impacting both investment returns and broader Global trajectories to Net Zero emissions. Such Portfolio "stress-tests"
              also help reveal the related Corporate winners/losers - and equity valuations - in the Global energy transition to 2050.`}
              />
              <CustomizedAccordions
                title="risk2NZ App Macro-Financial Scenarios"
                body={`.MEF's pre-run scenarios  can assist <b>investment committees</b> and other investment professionals & wealth managers
              in seeking to quantify Portfolio exposure in a highly uncertain Global economy facing multiple, ongoing shocks. 
              The <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> App allows users to explore these scenarios & the 
              shock-impacts on typical investment Portfolios and/or upload their own Portfolio for more direct stress-testing. It also allows
              users to inspect latest Esg ratings for typical investment portfolios (eg 60:40 Equity:Bonds) and the ability to input their own
              Portfolio asset allocation across Countries, Assets & Sectors to obtain an instant Esg-rating`}
              />
              <CustomizedAccordions
                title="Bespoke Portfolio Modelling & Esg Fund-Ratings"
                body={`MEF can construct customised, satellite Portfolio models with explicit macro-financial linkages to key drivers variables in the MEF model suite; this enables the
              modelling & direct quantification of portfolio returns risk from macro/energy shocks. MEF can also <a title="Environmental, Societal & Governmental"> Esg</a>-rate Funds by mapping Country-Sector exposure
              of underlying investments to the <a title="GreenHouse Gases"> GHG</a> intensities in MEF models -we call this an <b>"Esg"</b> Fund rating as it focuses on "hard" Emissions/Energy data for "E" `}
              />
              {/* <CustomizedAccordions
                title="Case Studies"
                body={`Links to specific Case Studies HERE`}
              /> */}
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default Who;

// Mobile Apps and Webtools - powered by Global models/data
